module.exports = __webpack_public_path__ + "img/performance.e23ae8ab.svg";